export const langText: any = {
    us: {
        link_more: 'Learn More',
        link_buy: 'Buy Now',
        text_link: 'coming soon',
    },
};
